<div class="card">
    <div class="card-header">
      <h4>Audit Trail</h4>
    </div>
    <div class="card-body m-0">
      <div class="row mb-2">
        <div class="col-xl-10">
          <button type="button" class="btn bg-danger-custom" (click)="onExportCSV()">
            <i class="feather icon-download me-2"></i>Export Excel</button>
          <button type="button" class="btn bg-danger-custom"
            (click)="quickFilterShowAction($event)"><i class="feather icon-filter me-2"></i>Quick Filters</button>
          <div class="btn-group mb-1 mb-md-0">
            <!--      <button type="button" class="btn bg-danger-custom">Columns</button>-->
            <div class="btn-group" ngbDropdown role="group">
              <button class="btn bg-danger-custom" ngbDropdownToggle><i class="feather icon-columns me-2"></i>Columns</button>
              <div ngbDropdownMenu class="ng-dropdown-panel-items p-1"
                style="height: 250px;width: 250px; overflow: scroll; scroll-behavior: smooth">
                <div class="form-group">
                  <!--            <label for="columns" class="form-label"> All Columns</label>-->
                  <div *ngIf="columnDefs" class="list-group ng-option">
                    <span *ngFor="let column of columnDefsCopy; let i = index" class="checkbox">
                      <label class="list-group-item p-2">
                        <input class="form-check-input me-1" type="checkbox" style="margin-left: 180px;" value="{{i}}" name="{{column.headerName}}"
                          (change)="updateSelectedColumn($event)"
                          [checked]="(tableSelectedColumn && (-1 !==tableSelectedColumn.indexOf(column)) ? 'checked': '')" />
                        {{(column?.headerName?.replace('_','') || column?.field?.replace('_','') ) }}
                      </label>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  
  
  
      
      <div *ngIf="quickFilterShow" class="row" style="min-height: 100px">
      
  
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-4">
                  <label class="col-form-label" for="resellerPartnerId">Module</label>
                  <ng-select #filStatus [items]="moduleDropDown" bindLabel="name" bindValue="value"
                    [(ngModel)]="selectedModule" placeholder="Select Module" required [inputAttrs]="{maxlength: '40'}" id="Status"
                    (focus)="fun('Status')" (focusout)="funover('Status')">
                  </ng-select>
                </div>
                <div class="col-md-4">
                  <label class="col-form-label" for="resellerPartnerId">Operation</label>
                  <ng-select #filResellerPartnerId [items]="operationDropDown" bindLabel="name" bindValue="value"
                    [(ngModel)]="selectedOperation" placeholder="Select Operation" required [inputAttrs]="{maxlength: '40'}" id="Status"
                    (focus)="fun('Status')" (focusout)="funover('Status')">
                  </ng-select>
                </div>
                <div class="col-md-4">
                  <label class="col-form-label" for="resellerPartnerId">Entity Key</label>
                <input class="form-control" [(ngModel)]="selectedEntityId" id="selectedEntityId" placeholder="Enter Entity ID"
                (focus)="fun('selectedEntityId')" (focusout)="funover('selectedEntityId')">
                </div>
                <div class="col-md-4">
                  <div class="row">
                    <div class="col-md-6  ">
                      <label class="col-form-label" for="searchMID">Date From</label>
                      <input #filSearchFromDate [(ngModel)]="searchFromDate"
                      ngbDatepicker #d="ngbDatepicker" class="form-control" id="searchFromDate" placeholder="yyyy-mm-dd"
                      [maxDate]="maxDateFrom" (click)="d.toggle()" (ngModelChange)="changeDate()" />
                    </div>
                    <div class="col-md-6">
                      <label class="col-form-label" for="searchMID">Date To</label>
                      <input #filSearchToDate [(ngModel)]="searchToDate" class="form-control" id="searchToDate"
                      ngbDatepicker #d1="ngbDatepicker"  (click)="d1.toggle()" placeholder="yyyy-mm-dd"
                      [maxDate]="maxDate" [minDate]="minDate" (ngModelChange)="changeEndDate()" />
                    </div>
                  </div>
                </div>
                <div class="col-sm-4 d-flex align-items-end">
                  <button (click)="onSearchBtnClick($event)" class="btn bg-danger-custom me-2" type="button" style="width: 100%;">
                    <i class="feather icon-search me-2"></i>Search
                  </button>
                  <button (click)="resetFilter()" class="btn bg-secondary" type="button" style="width: 100%;">
                    <i class="feather icon-refresh-cw me-2"></i>Reset
                  </button>
                </div>
  
              </div>
  
  
            </div>
          </div>
        
      </div>
      <div class="row mb-0" style="min-height: 470px">
        <div class="col-12 col-xl-12 grid-margin stretch-card ag-theme-alpine" style="margin-bottom: 0px">
          <ag-grid-angular [enableCellTextSelection]=true (sortChanged)="onSortChange($event)"
            (filterChanged)="onFilterChange($event)" (filterModified)="onFilterModified($event)"
            (filterOpened)="onFilterOpened($event)" (gridReady)="onGridReady($event)" (rowClicked)="onRowClicked($event)"
            (rowDoubleClicked)="onRowDoubleClicked($event)" (search)="globalSearch" [columnDefs]="tableSelectedColumn"
            [defaultColDef]="defaultColDef" [enableCellTextSelection]=true [paginationPageSize]="pageSize"
            [pagination]="true" [rowData]="rowData" [rowModelType]="" [rowSelection]="'single'"
            [suppressPaginationPanel]="true" style="width: 100%; height: auto;">
          </ag-grid-angular>
        </div>
      </div>
      <div class="row mt-0">
        <div class="col-4 col-xs-4 d-flex">
          <select (change)="onPageSizeChanges($event)" [(ngModel)]="pageSize"
            class="form-select d-flex justify-content-end col-4" name="pageSize" style="width: auto">
            <option *ngFor="let pageNum of pageSizeArr" [ngValue]="pageNum">{{pageNum}}</option>
          </select>
          <p class="text-muted p-3"> Total Records: {{ collectionSize }}</p>
        </div>
  
        <div class="col-8 col-xs-8">
          <ngb-pagination (pageChange)="onPaginationChange($event)" [(page)]="currentPage" [boundaryLinks]="true"
            [collectionSize]="collectionSize" [maxSize]="5" [pageSize]="pageSize" [rotate]="true" [directionLinks]="true"
            [ellipses]="false" size="sm" class="d-flex justify-content-end align-right">
          </ngb-pagination>
        </div>
  
      </div>
    </div>
  
  </div>
  
  <!-- <app-modal #modalAdd [modalConfig]="modalConfigAdd">
   &lt;!&ndash;  body of the modal  &ndash;&gt;
   <app-merchant-add (closeModal)="closeModalAdd($event)"></app-merchant-add>
  </app-modal> -->
  <!-- <app-modal #modalEdit [modalConfig]="modalConfigEdit">
   &lt;!&ndash;  body of the modal  &ndash;&gt;
   <app-merchant-edit [editData]="modalConfigEdit"></app-merchant-edit>
  </app-modal> -->
  <!-- <app-modal #modalMerchant [modalConfig]="modalConfigMerchant">
   &lt;!&ndash;  body of the modal  &ndash;&gt;
   <app-merchantriskconfig [merchantId]="Merchantdata" [onConfigChange]="merchantConfigEvent"></app-merchantriskconfig>
  </app-modal> -->
  <!-- <app-modal #modalMerchantBank [modalConfig]="modalConfigMerchant">
   &lt;!&ndash;  body of the modal  &ndash;&gt;
  <app-account-list [merchantId]="selectedMerchant" [onMerchantChange]="merchantSelectEvent" ></app-account-list>
  </app-modal> -->
  
  <!-- <app-modal #modalbloked [modalConfig]="modalConfigBlocked">
   
  <app-merchant-blocked (closeModal)="closeModalBlocked($event)" [merchantStatusConfig]="tableInfo"
    [onMerchantMId]="BlockedmerchantSelectEvent">
  </app-merchant-blocked> 
  <div>Delete </div> 
  </app-modal>  -->
  <app-modal #modalblokedCustomer [modalConfig]="modalConfigBlocked">
     
    <app-customer-blocked (closeModal)="closeModalBlocked($event)" [merchantStatusConfig]="tableInfo"
      [onMerchantMId]="BlockedmerchantSelectEvent">
    </app-customer-blocked> 
   <div>Delete </div> 
    </app-modal> 

    <app-modal #modalReportCustomer [modalConfig]="modalConfigReport" >
      <!-- <label class="switch">
        <input type="checkbox" id="togBtn" (change)="onToggle($event)">
        <div class="slider round">
         <span class="on">JSON</span>
         <span class="off">TABLE</span>
        </div>
       </label> -->

    <div class="row text-center">
      <p>Note:
        <span class="text-success">Green color indicates addition</span> | 
        <span class="text-danger">Red color indicates removal</span> | 
        <span class="text-warning">Yellow color indicates updation</span>
      </p>
    </div>
    <div class="row">
        <ul class="nav nav-tabs" id="myTab" role="tablist">
            <li class="nav-item" role="presentation">
                <a class="nav-link" [class.active]="activeTab === 'json'" (click)="switchTab('json')">JSON</a>
            </li>
            <li class="nav-item" role="presentation">
                <a class="nav-link" [class.active]="activeTab === 'table'" (click)="switchTab('table')">TABULAR</a>
            </li>
          </ul>
    </div>

    <div class="tab-content pt-2" id="myTabContent">
      <div id="json" class="tab-pane fade p-4 active show" [ngStyle]="{ 'display': activeTab === 'json'? 'block' : 'none'}">
        <div class="row d-flex">
          <div class="form-group col-md-6 ">
              <h5 class="text-center" style="font-weight: bold;">Before</h5>
              <pre [innerHtml]="beforeData | json" *ngIf="beforeData"></pre>
              <p *ngIf="!beforeData" class="text-center mt-4">No Data To Show</p>
          </div>
          <div class="form-group col-md-6 ">
              <h5 class="text-center" style="font-weight: bold;">After</h5>
              <pre [innerHtml]="afterData | json" *ngIf="afterData"></pre>
              <p *ngIf="!afterData" class="text-center mt-4">No Data To Show</p>
          </div>
      </div>
      </div>
      <div id="table" class="tab-pane fade p-4 active show" [ngStyle]="{ 'display': activeTab === 'table'? 'block' : 'none'}">
        <div class="row d-flex">
          <div class="form-group col-md-6 ">
            <h5 class="text-center" style="font-weight: bold;">Before</h5>
            <table class="table table-bordered">
              <tr class="thead-light" *ngFor="let data of beforeData | keyvalue">
                <th scope="col">{{data.key}}</th>
                <td [innerHTML]="data.value"></td>
              </tr>
            </table>
            <p *ngIf="!beforeData" class="text-center mt-4">No Data To Show</p>
          </div>
          <div class="form-group col-md-6 ">
            <h5 class="text-center" style="font-weight: bold;">After</h5>
            <table class="table table-bordered">
              <tr class="thead-light" *ngFor="let data of afterData | keyvalue">
                <th scope="col">{{data.key}}</th>
                <!-- <td scope="col">{{data.value}}</td> -->
                <td [innerHTML]="data.value"></td>
              </tr>
            </table>
            <p *ngIf="!afterData" class="text-center mt-4">No Data To Show</p>
          </div>
        </div>
      </div>
    </div>
    </app-modal> 